<template>
  <b-container class="px-0">
    <b-row class="justify-content-md-center">
      <b-col cols=12>
        <b-card no-body 
          tag="h1" 
          class="border-0 pt-3 pb-3 bg-transparent"
        >{{pageTitle}}
        </b-card>
      </b-col>
    </b-row>
    <b-row class="justify-content-md-center">
      <b-col cols="12" md="6" xl="4" class="mb-4" v-for="articol in articles" v-bind:key="articol.id">
        <b-card
          :img-src="articol.uagb_featured_image_src.full === false ? require('../assets/imgplacehold.png') : articol.uagb_featured_image_src.full[0]"
          img-alt="Biblioteca Județeană Arad"
          img-top
          tag="article"
          class="shadow p-0 mb-4 rounded bg-transparent"
          fluid
        >
          <b-card-title title-tag="h3" v-html="articol.title.rendered"></b-card-title>
          <b-card-text v-html="articol.uagb_excerpt"></b-card-text>
          <div class="d-flex justify-content-center">
            <b-button squared variant="primary" class="px-4 my-2 btn-index-card">
              <router-link :to="{ path: '/articol/'+ articol.id}">Citește articolul</router-link>
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

export default {
  props: ['mode'],
  data() {
    return {
      articles: {},
      pageTitle: "Ultimele știri"
    };
  },
  methods: {
    getArticles() {
      fetch('https://bibliotecaarad.ro/wp-json/wp/v2/posts?orderby=date&order=desc&categories=568')
                .then(response => response.json())
                .then(data => this.articles = data);
    }
  },
  created() {
    this.getArticles();
  }
};
</script>
